/* Keep app controls separate without changing consent, cart or chat behaviour. */
(() => {
  const body = document.body;
  if (!body.classList.contains('artimotion-gallery')) return;
  const mobile = matchMedia('(max-width: 749px)');
  let frame;
  const watched = new Set();
  const height = (element) => {
    if (!element || getComputedStyle(element).visibility === 'hidden') return 0;
    return Math.ceil(element.getBoundingClientRect().height);
  };
  const set = (name, value) => {
    const next = `${value}px`;
    if (body.style.getPropertyValue(name) !== next) body.style.setProperty(name, next);
  };
  const update = () => {
    frame = null;
    const cookie = document.querySelector('.cb-cookie_consent-container');
    const bar = document.querySelector('#PBarNextFrameWrapper');
    const sticky = document.querySelector('.product__mobile-sticky-atc');
    const primary = document.querySelector('product-info .product-form__submit');
    const elements = [cookie, bar, sticky, primary].filter(Boolean);
    for (const element of watched) {
      if (!elements.includes(element)) { resize.unobserve(element); watched.delete(element); }
    }
    for (const element of elements) {
      if (!watched.has(element)) { resize.observe(element); watched.add(element); }
    }
    const showSticky = !!(mobile.matches && primary && primary.getBoundingClientRect().bottom < 0);
    body.classList.toggle('gallery-sticky-visible', showSticky);
    body.classList.add('gallery-overlays-ready');
    // The preview toolbar may collapse to a small handle. Its actual height is used.
    set('--gallery-preview-height', height(bar));
    set('--gallery-cookie-height', height(cookie));
    set('--gallery-sticky-height', showSticky ? height(sticky) : 0);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const resize = new ResizeObserver(schedule);
  new MutationObserver(schedule).observe(body, { childList: true, subtree: true });
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
